export interface JobDie {
  die_id     : string,
  code       : string,
  name       : string,
  template_id: string,
  tph        : string
};


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/models/jobDie.model.ts